!function(){"use strict";var t;(t=Ya.Rum).logAjaxError=function(a,i,o,n){a.type="network",a.additional=a.additional||{},"timeout"===o?a.additional.timeout=1:i.status&&(a.additional.status=i.status),t.logError(a,n)}}();
